export const USAGE_UNITS = ["ml", "gram", "kg", "litre", "adet"];
export const CATEGORIES = ["İlaç", "Aşı"];
export const EMPTY = { name: "", category: "İlaç", usage_unit: "ml", stock: 0, unit_price: 0, min_stock: 0, expiry_date: "", supplier: "", notes: "" };

export const DOSE_UNITS_FOR = (stockUnit) => {
  const u = (stockUnit || "").toLowerCase();
  if (["litre", "ml", "lt", "cc"].includes(u)) return ["ml", "litre"];
  if (["kg", "gram", "gr", "g"].includes(u)) return ["gram", "kg"];
  return [u || "adet"];
};

export const expiryBadge = (status, days) => {
  if (status === "expired") return { cls: "bg-[#FBECEA] text-[#C45B45] border-[#f2d4cb]", txt: `SKT geçti (${Math.abs(days)} gün önce)` };
  if (status === "expiring_soon") return { cls: "bg-[#FEF6E0] text-[#8B6914] border-[#EED7A6]", txt: `SKT ${days} gün` };
  return null;
};

export const EMPTY_BULL = { bull_name: "", bull_code: "", payet_count: 0, invoice_amount: 0, min_stock: 5, semen_type: "konvansiyonel", supplier: "", notes: "" };
export const EMPTY_PROTOCOL = { name: "", disease: "", default_duration_days: "", items: [], notes: "" };
let _muidc = 0;
export const muid = () => `mp${Date.now().toString(36)}${(_muidc++).toString(36)}`;
